import {toast} from "react-toastify";
import i18n from "i18next";
import {FcmErrorCode, ResponseFcm} from "app/model/response-fcm";
import {ResponseApi, ResponseResultCode} from "app/model/response-api";
import axios, {AxiosResponse, HttpStatusCode} from "axios";
import {HeadersUtil} from "app/utils/headersUtil";
import {isStringNullOrEmpty} from "app/utils/stringUtil";
import store from "../../store/store";
import {clearUserInfo} from "app/reducers/userSlice";

export class FirebaseService {
  private static firebaseService: FirebaseService;
  private static readonly SAVE_DEVICE_TOKEN_URL: string = process.env['REACT_APP_URL_FCM'] + '/uid';
  private static readonly GET_MESSAGE_URL: string = process.env['REACT_APP_URL_FCM'] + '/message';
  private static readonly READ_MESSAGE_URL: string = process.env['REACT_APP_URL_FCM'] + '/message/read';
  private static readonly READ_ALL_MESSAGE_URL: string = process.env['REACT_APP_URL_FCM'] + '/message/messages/read';
  private static readonly GET_MESSAGE_TYPE_URL: string = process.env['REACT_APP_URL_FCM'] + '/message/type';
  private static readonly PUT_MESSAGE_TYPE_URL: string = process.env['REACT_APP_URL_FCM'] + '/message/type';
  private static readonly PUT_MESSAGE_TYPE_ALL_URL: string = process.env['REACT_APP_URL_FCM'] + '/message/type/types';

  public static getInstance(): FirebaseService {
    if (!FirebaseService.firebaseService) {
      FirebaseService.firebaseService = new FirebaseService();
    }
    return FirebaseService.firebaseService;
  }

  /**
   * Firebase instance initialize before API.ts initialize
   * cause error when inherit API.ts class
   * Temporary copy needed function for request and response
   * **/

  private async convertResult<T>(response: Promise<AxiosResponse>) {
    let defaultErrorMsg = i18n.t("common.message.error.duringProcessing");

    try {
      const response_1 = await response;
      const resp: ResponseApi<T> = response_1.data;
      if (resp instanceof Blob) {
        if (HttpStatusCode.Ok === response_1.status) {
          // return this.downloadResponseFile(resp, response_1.config.url);
        }
      } else {
        if (HttpStatusCode.Ok === resp.statusCode) {
          if (ResponseResultCode.E === resp.resultCode) {
            toast.error(
                isStringNullOrEmpty(resp.errorMessage)
                    ? defaultErrorMsg
                    : resp.errorMessage
            );
            return null;
          }
          return resp;
        } else {
          toast.error(
              isStringNullOrEmpty(resp.errorMessage)
                  ? defaultErrorMsg
                  : resp.errorMessage
          );
          return null;
        }
      }
    } catch (error: any) {
      return this.convertResultError(error);
    }
  }

  private convertResultError(error: any) {
    const code = error.code;
    const status = error.response?.status;

    if (status === 401) {
      store.dispatch(clearUserInfo());
    } else if ("ECONNABORTED" === code || 408 === status) {
      // toast.error(isStringNullOrEmpty(error.message) ? Api.defaultErrorMsg : error.message);
    } else {
      const resp: ResponseApi<null> = error.response?.data;
      // toast.error(isStringNullOrEmpty(resp?.errorMessage) ? Api.defaultErrorMsg : resp.errorMessage);
    }

    return null;
  }


  public async saveDeviceToken(token: any) {
    return await this.convertResult<any>(axios.post<any>(FirebaseService.SAVE_DEVICE_TOKEN_URL, token, {headers: HeadersUtil.getHeadersAuth()}));
  }

  public async getMessage(param : any) {
    return this.convertResult( axios.get(FirebaseService.GET_MESSAGE_URL,
      {
        headers: HeadersUtil.getHeadersAuth(),
        params: {
          uid: param.userId,
          fromDt: param.month,
        },
      })
    );
  }

  public async readMessage(request: any) {
    return await this.convertResult<any>(axios.put<any>(FirebaseService.READ_MESSAGE_URL, request, {headers: HeadersUtil.getHeadersAuth()}));
  }

  public async readAllMessage(request: any[]) {
    return await this.convertResult<any>(
        axios.put<any, AxiosResponse<ResponseApi<any>>>(FirebaseService.READ_ALL_MESSAGE_URL, request, { headers: HeadersUtil.getHeadersAuth() })
    );
  }

  public async getMessageType() {
    return await this.convertResult<any>(axios.get<any>(FirebaseService.GET_MESSAGE_TYPE_URL, {headers: HeadersUtil.getHeadersAuth()}));
  }

  public async putMessageType(request: any) {
    return await this.convertResult<any>(axios.put<any>(FirebaseService.PUT_MESSAGE_TYPE_URL, request, {headers: HeadersUtil.getHeadersAuth()}));
  }

  public async putMessageTypes(request: any[]) {
    return await this.convertResult<any>(axios.put<any>(FirebaseService.PUT_MESSAGE_TYPE_ALL_URL, request, {headers: HeadersUtil.getHeadersAuth()}));
  }

  public sendMessage(request: any) {
    this.convertResult<any>(
      axios.post<ResponseFcm>(FirebaseService.GET_MESSAGE_URL, request, {
        headers: HeadersUtil.getHeadersAuth(),
      })
    )
    .then(response => this.sendMessageResponse(response))
    .catch(() => toast.error(i18n.t('common.fm.error.send')));
  }

  private sendMessageResponse(response: void | ResponseApi<ResponseFcm> | null) {
    if (response && ResponseResultCode.Y === response.resultCode) {
      if (response.data) {
        if (response.data.result) {
          toast.success(i18n.t('common.fm.success.send'));
        } else {
          if (response.data.errorCode) {
            switch (response.data.errorCode) {
              case FcmErrorCode.UNKNOWN_UID:
                toast.error(i18n.t('common.fm.error.unknownUid'));
                break;
              case FcmErrorCode.UNREGISTERED:
                toast.error(i18n.t('common.fm.error.unregistered'));
                break;
            }
          }
        }
      } else {
        toast.error(i18n.t('common.fm.error.send'));
      }
    } else {
      toast.error(i18n.t('common.fm.error.send'));
    }
  }
}